<template>
  <div v-if="hasHours" class="hours-block">
    <div class="hours-heading__row">
      <div class="hours-heading">
        <h3 class="heading">{{ heading }}</h3>
        <button
          class="now hasPointer"
          v-if="!hours.overrideText"
          tabindex="0"
          @click="expanded = !expanded"
          :aria-controls="idcontrol + '-' + heading"
          :aria-expanded="expanded ? 'true' : 'false'"
        >
          <div class="now" v-if="!hours.overrideText">
            <span v-if="listViewContext.hours.indexOf('Closed') > -1">
              {{ listViewContext.dow }} |
              <span class="closed-now">{{ listViewContext.hours }}</span>
            </span>
            <span v-else>
              <span v-if="openNow" class="open-now">Open Now</span>
              <span v-else class="closed-now">Closed Now</span> |
              {{ listViewContext.hours }}
            </span>
          </div>
        </button>
      </div>
      <div class="hours-button">
        <button
          v-bind:class="{ 'pill large': true }"
          type="button"
          @click="expanded = !expanded"
          :aria-controls="idcontrol + '-' + heading"
          :aria-expanded="expanded ? 'true' : 'false'"
        >
          <span class="sr-only">Show </span
          >{{ expanded ? "Less Hours" : "More Hours" }}
          <span v-bind:class="{ caret: true, expanded: expanded }"></span>
        </button>
      </div>
    </div>

    <transition v-if="!hours.overrideText" name="slide">
      <ul v-if="expanded" class="details" :id="idcontrol + '-' + heading">
        <li v-for="dow in daysOfWeek" :key="dow.day">
          <span class="day">{{ dow.abbreviation }}</span>
          <span class="time">{{ timeFormat(dow.day) }}</span>
        </li>
      </ul>
    </transition>
    <span v-if="hours.overrideText" v-html="hours.overrideText"></span>
  </div>
</template>

<script>
import moment from "moment";
import { locText } from "../../../utils/useText";
import {
  getDOW,
  filterAsOpen,
  getDateFromDayOfWeek,
} from "../functions/filters";

export default {
  data() {
    return {
      expanded: false,
      daysOfWeek: [
        { day: "monday", abbreviation: "Mon", index: 1 },
        { day: "tuesday", abbreviation: "Tue", index: 2 },
        { day: "wednesday", abbreviation: "Wed", index: 3 },
        { day: "thursday", abbreviation: "Thu", index: 4 },
        { day: "friday", abbreviation: "Fri", index: 5 },
        { day: "saturday", abbreviation: "Sat", index: 6 },
        { day: "sunday", abbreviation: "Sun", index: 7 },
      ],
    };
  },
  computed: {
    hasHours: {
      get() {
        let hasHours = false;
        for (var i in this.daysOfWeek) {
          let day = this.daysOfWeek[i];
          if (this.hours[day.day]) {
            hasHours = true;
            break;
          }
        }
        if (!hasHours) {
          hasHours =
            this.hours.overrideText && this.hours.overrideText.length > 0;
        }
        return hasHours;
      },
    },
    listViewContext: {
      get() {
        let dow = getDOW(),
          payload = {
            dow: dow,
            hours: this.timeFormat(dow),
          };

        return payload;
      },
    },
    openNow: {
      get() {
        return filterAsOpen(this.location, this.hours);
      },
    },
  },
  methods: {
    timeFormat(dayOfWeek) {
      let hours = this.hours[dayOfWeek.toLowerCase()],
        dayIndex = this.dayOfWeekIndex(dayOfWeek.toLowerCase());
      if (hours && hours.open && hours.close) {
        if (this.isHoliday(dayIndex)) {
          return "Closed for Holiday";
        }
        if (
          (hours.open === "00:00" ||
            hours.open === "00:00:00" ||
            hours.open === "12:00:00 AM") &&
          (hours.close === "23:59" ||
            hours.close === "23:59:00" ||
            hours.close === "23:59:59" ||
            hours.close === "11:59:00 PM" ||
            hours.close === "11:59:59 PM")
        ) {
          return "Open 24 hours";
        }

        return (
          moment(hours.open, ["HH:mm:ss"]).format("h:mm A") +
          " - " +
          moment(hours.close, ["HH:mm:ss"]).format("h:mm A")
        );
      } else {
        return "Closed";
      }
    },
    isHoliday(dayOfWeek) {
      if (typeof this.holidays === "undefined" || this.holidays.length === 0) {
        return false;
      }

      var d = getDateFromDayOfWeek(dayOfWeek);
      if (this.holidays.indexOf(d) > -1) {
        return true;
      }
      return false;
    },
    dayOfWeekIndex: function (dayOfWeek) {
      let index = 0;
      this.daysOfWeek.forEach((element) => {
        if (element.day === dayOfWeek) {
          index = element.index;
        }
      });
      return index;
    },
  },
  props: {
    detailView: Boolean,
    heading: String,
    hours: Object,
    location: Object,
    idcontrol: String,
    holidays: Array,
  },
};
</script>
